<template>
    <div class="orderdetails">
        <div class="order_div">
            <div><span>订单信息</span></div>
            <div class="order_xinxi">订单信息</div>
            <div class="order_title">
                <p class="order_p">
                    <span>订单编号：</span>
                    <span>下单时间：</span>
                </p>
                <div class="order_const">
                    <img src="" alt="">
                    <div class="oeder_fix">
                        <p>title</p>
                        <p>订单状态: <span>已失效</span></p>
                        <p>购买数量: </p>
                        <p>课程总价: </p>
                        <p>付款方式: </p>
                        <p>订单总金额: <span>180.00元</span></p>
                    </div>
                </div>
                <div class="order_xs">
                    <span>目标学时：必修30(不低于24)</span>
                </div>
                <div class="order_stop">

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import qs from 'qs'

export default {
    name:'orderdetails',
    data(){
        return{
            
            uid:'',
            token:'',
            page:1,
        }
    },
    created (){
        this.uid= localStorage.getItem('uid')
        this.token=localStorage.getItem('token')
        //console.log(this.uid,this.token)
        
        if(this.token){
            this.getOrder()
        }else{
            this.removeInfo()
        }
        this.zhuanye()
    },
    mounted(){
        var that=this
        var order_data={
            uid:this.uid,
            token:this.token,
            page:this.page,
            num:this.num,
        }
        this.$axios.post('/pay/get_pay_order',
            qs.stringify(order_data)
        ).then(res =>{
            if(res.data.status=="ok"){
                that.count=Number(res.data.data.count);
                // if(that.count/6>1){
                //     that.pagevalue=true;
                // }
                that.data=[]
                that.data=that.data.concat(res.data.data.data)
                //console.log( that.data)
                if(that.count>0){
                    that.nodata=false
                }else{
                that.nodata=true
                }
            }else if((res.data.status=="error")){
            this.$message.error({message:res.data.errormsg,duration:1600});
            } 
        // if((res.data.status=="relogin")){
        //     this.$message.error({message:"重新登录",duration:1600});
        //     // that.removeInfo();
        // }
        })
    },
    
}
</script>
<style scoped lang="less">
    .order_div{
        margin: 20px auto;
        height: 708px;
        width: 948px;
        background: #fff;
        div:nth-child(1){
            height: 57px;
            background: #fafafa;
            line-height: 57px;
            span{
                color: #469bee;
                padding-bottom:16px;
                border-bottom:2px #469bee solid;
                margin-left: 20px;
            }
        }
        .order_xinxi{
            height: 35px;
            background: #469bee;
            color: #fff;
            line-height: 35px;
            text-indent:20px;
            margin-top:10px;
        }
        .order_title{
            height: 653px;
            .order_p{
                border: 1px #e3e3e3 solid;
                height: 35px;
                width: 948px;
                line-height: 35px;
                margin-top:10px; 
                span:nth-child(1){
                    float: left;
                    margin-left:20px;
                }
                span:nth-child(2){
                    padding: 0;
                    float: right;
                    margin-right:20px;
                }
            }
            
        }
    }
    img{
        margin: 0 20px 20px;
        height: 200px;
        width: 321px;
        border: 1px #f00 solid;
        float: left;
    }
    .order_const{
        height: 240px;
        margin-top:20px; 
    }
    .oeder_fix{
        float: left;
        height: 200px;
        width: 400px;
        p:nth-child(1){
            font-size: 16px;
            margin: 10px 0;
            display: block;
        }
        p:nth-child(n+2){
            font-size:14px;
            margin-top:10px; 
            span{
                color: #f00;
                font-size: 16px;
            }
        }
    }
    .order_xs{
        height: 53px;
        width: 400px;
        line-height: 53px;
        margin-left: 20px;
        span{
            color: #f00;
        }
    }
    .order_stop{
        height: 200px;
        width: 908px;
        margin: 0 auto;
        text-indent:20px;
        overflow: hidden;
    }
</style>


// WEBPACK FOOTER //
// src/components/orderdetails.vue